import { IssueResponseModel } from "../types/IssueResponseModel";
import { IssueModel } from "../types/IssueModel";
import moment from "moment";

export function mapIssueFromResponse(r: IssueResponseModel): IssueModel {
  return {
    id: r.id,
    idFriendly: r.idFriendly,
    title: r.title,
    description: r.description,
    assignedTo: r.assignedTo,
    issueTypeId: r.issueTypeId,
    status: r.status,
    dueOn: r.dueOn && moment(r.dueOn),
    additionalProperties: r.additionalProperties,
    geoanchor: r.geoanchor,
    createdOn: r.createdOn && moment(r.createdOn),
    createdBy: r.createdBy,
    watchedBy: r.watchedBy,
    authorizedActions: new Set(r.authorizedActions),
    authorizedStatuses: r.authorizedStatuses,
  };
}
